//copied from FEvIR Platform but did not get it working in computablepublishing-site
const scrollTo = (segment, id, navigateById, navbarId) => {
    if (navigateById) {
        let scrollToElement;
        let scroll = true;
        if (id !== 0 && id !== "") {
            let scrollToElementById = document.getElementById(id);
            if (scrollToElementById) {
                scrollToElement = scrollToElementById.offsetTop;
            } else {
                scroll = false;
            }
        } else {
            scrollToElement = 0;
        }
        if (navbarId) {
            let offset = 0;
            let navbar = document.getElementById(navbarId);
            //console.log(window.getComputedStyle(navbar).height);
            offset = navbar.offsetHeight * 2;
            //console.log(offset);
            scrollToElement += offset;
        }
        if (scroll && !segment) {
            window.scrollTo({
                'behavior': 'smooth',
                'top': scrollToElement
            });
        } else if (scroll && document.getElementById(segment)) {
            document.getElementById(segment).scrollTo({
                'behavior': 'smooth',
                'top': scrollToElement
            });
        }
    }
};

export default scrollTo;